export const addBusinessError = () => ({
  type: "ADD_BUSINESS_ERROR",
});

export const addBusinessLoading = () => ({
  type: "ADD_BUSINESS_LOADING",
});

export const addBusinessSuccess = (business) => ({
  type: "ADD_BUSINESS_SUCCESS",
  business,
});
